import { createApi} from "@reduxjs/toolkit/query/react";
import {  stagingURL,  } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const seasonManagerAPI = createApi({
    reducerPath: "scheduleManagerAPI",
    baseQuery: axiosBaseQuery({ baseUrl:stagingURL }),
    endpoints: () => ({}),
});
